export enum EsriMarkerType {
  PIN,
  SQUARE,
  CIRCLE,
  CIRCLE_PIN,
  IMAGE,
}
